import {
  Flex,
  Heading,
  Text,
  GridItem,
  LinkBox,
  Badge,
  useBoolean
} from '@chakra-ui/react'
import { FC } from 'react'
import { Link } from 'react-router-dom'

import { ILinkMenu } from '@base/@types/components/Layout/Navigator'

const DropdownItem: FC<ILinkMenu> = ({
  name,
  icon,
  path,
  colSpan,
  badge,
  description
}) => {
  const [hover, setHover] = useBoolean(false)

  return (
    <GridItem
      pos="relative"
      colSpan={colSpan || 1}
      p={2}
      cursor="pointer"
      onMouseEnter={setHover.on}
      onMouseLeave={setHover.off}
      transition="padding linear .1s"
      _before={{
        content: "' '",
        pos: 'absolute',
        w: 'calc(100% + 20px)',
        h: 'calc(100% + 20px)',
        top: '-10px',
        left: '-12px',
        borderRadius: 8,
        opacity: 0,
        transition: 'opacity .2s linear,transform .2s ease-out',
        bgColor: 'rgba(249, 232, 0, 0.2)'
      }}
      _hover={{
        px: 2,
        _before: {
          opacity: 1,
          transform: colSpan ? 'scale(0.94)' : 'scale(0.9)'
        }
      }}
    >
      <LinkBox as={Link} to={path}>
        <Flex
          w="40px"
          h="40px"
          alignItems="center"
          justifyContent="center"
          fontSize="18px"
          borderRadius="8px"
          mb={4}
          bg={hover ? '#1d5840' : 'gray.100'}
          color={hover ? '#fff' : '#1d5840'}
          transition="all ease .3s"
        >
          {icon}
        </Flex>
        <Heading size="xs" mb={1}>
          {name}{' '}
          {badge && (
            <Badge bg={badge.color} color="white" fontSize="10px">
              {badge.label}
            </Badge>
          )}
        </Heading>
        <Text fontSize="xs" lineHeight="1.4">
          {description}.
        </Text>
      </LinkBox>
    </GridItem>
  )
}

export default DropdownItem
